//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DecisionTree } from "../utils/DecisionTree";
import { mapState, mapGetters } from "vuex";

export default {
  props: {
    tree: {
      type: DecisionTree,
      default: null
    }
  },
  data: function () {
    return {
      title: "Drill Movement",
    };
  },
  computed: {
        ...mapState({
      drillingInProgress: state => state.drilling.drillingInProgress,
      drillSegmentProgress: state => state.drilling.drillSegmentProgress,
      drillSegmentLength: state => state.drilling.drillSegmentLength,
    }),
    ...mapGetters("drilling", ["drillProgressLabel"]),
    stepSize: {
      get() {
        return this.$store.state.drilling.stepSize;
      },
      set(value) {
        if(value =="") {
          this.$store.commit("drilling/updateStepSize", undefined)
        } else {
          this.$store.commit("drilling/updateStepSize", value);
        }
      }
    },
    fastStepBackButton: function() {
      let ret = this.drillingInProgress;
      if (!ret) {
        ret = this.tree != null && this.tree.peekNextStepBack() != null;
      }
      return ret;
    },
    //todo: check drillingInProgress related properties
    drillStepBackButton: function () {
      return (
        this.drillingInProgress &&
        this.drillSegmentProgress > 0
      );
    },
    drillStepButton: function () {
      return (
        this.drillingInProgress &&
        this.drillSegmentProgress < this.drillSegmentLength - 1e-5
      );
    },
    fastFwdButton: function () {
      let ret =
        this.drillingInProgress &&
        this.drillSegmentProgress < this.drillSegmentLength - 1e-5;
      if (!ret) {
        ret = this.tree != null && this.tree.peekNextStepFwd() != null;
      }
      return ret;
    }
  },
  methods: {
    validateStepSize () {
      if (!this.$store.state.drilling.stepSize) {
        alert("Step size must be set with an positive number. \n Step size was set to default value 250 meters.")
        this.$store.commit("drilling/updateStepSize", 250);
      }
    }
  }
};
